import QuestionFresher from "./QuestionFresher";



export function QuestionsTechnical() {

    return <QuestionFresher technicalQues={'technical'} />
}

export function QuestionsAptitude() {

    return <QuestionFresher technicalQues={'aptitude'} />
}

export function QuestionsProgramming() {

    return <QuestionFresher technicalQues={'programming'} />
}